module.exports = __webpack_public_path__ + "img/general_problem.9cd5af41.svg";